import axios from 'axios'
import _ from 'lodash'
import { useAuthStore } from 'src/stores'

/* ----------------------------- Business Client ---------------------------- */
const businessClient = () => {
  const authStore = useAuthStore()

  const client = axios.create({
    baseURL: `${authStore.loginData.business_url}/api/v1`,
    method: 'POST',
    withCredentials: false,
    headers: {
      'Content-Type': 'application/json',
      Accept: 'application/json',
    },
  })

  /* -------------------------------------------------------------------------- */
  /*                                   Request                                  */
  /* -------------------------------------------------------------------------- */
  client.interceptors.request.use((request) => {
    if (process.env.CLIENT && authStore.token) {
      request.headers.Authorization = `Bearer ${authStore.token}`
    }
    return request
  })

  /* -------------------------------------------------------------------------- */
  /*                                  Response                                  */
  /* -------------------------------------------------------------------------- */
  client.interceptors.response.use((response) => {
    if ('data' in response.data) return { ...response, meta: _.omit(response.data, ['data']), data: response.data.data }
    else return { ...response, meta: {}, data: response.data.data }
  })

  return client
}

export default businessClient
